module.exports = "<h3 mat-dialog-title class=\"text-center mb\">{{ title }}</h3>\n\n<mat-dialog-content class=\"pb-4 pt-3\" [innerHTML]=\"body\"></mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n  <button mat-button *ngIf=\"type === 'confirm'\" (click)=\"onCancel()\">Cancelar</button>\n  <button mat-raised-button color=\"primary\" (click)=\"onAccept()\">Aceptar</button>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user-feedback/dialog/dialog.component.html
// module id = ./src/app/modules/user-feedback/dialog/dialog.component.html
// module chunks = main